module.exports = __webpack_public_path__ + "img/connect-cp.145deb6c.png";